<template>
    <div class="form-group mr-b-0em">
        <div class="mb-2">
            <b class="form-label"> {{ props.TextLabel }} </b>
            <Multiselect :trackby="props.trackby" :valueProp="props.valueProp" :label="props.label"
                v-model="selectedValue" :options="props.arrayOptions" :allow-empty="false"
                deselect-label="Can't remove this value" :ref="props.refs" :searchable="true" @select="handleSelect"
                @change="handleDeselect" :placeholder="`${$t(props.placeholder)}`" />
            <span class="text-danger" v-for="error in $props.v?.$errors" :key="error.$uid">{{
                error.$message
            }}</span>
        </div>
    </div>

</template>

<script lang="ts">
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import { defineComponent, ref, computed, watch, PropType } from "vue";
export default defineComponent({
    components: { Multiselect },
    name: "SingleSelect",
    props: {
        modelValue: {
            default: null,
            type: [String, Number, null] as PropType<string | number | null>,
        },
        v: {
            type: Object,

        },
        TextLabel: {
            type: String,
        },
        label: {
            type: String,
        },
        valueProp: {
            type: [String, Number],
        },
        trackby: {
            type: [String, Number],
        },
        placeholder: {
            type: String,
            default: "",
        },
        refs: {
            type: String,
            default: "",
        },
        isEmpty: {
            type: Boolean,
            default: false,
        },
        arrayOptions: {
            type: Array,
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const selectedValue = ref(props.modelValue || null);
        const handleSelect = () => {
            emit('update:modelValue', selectedValue.value);
        };
        const handleDeselect = () => {
            emit('update:modelValue', selectedValue.value);
        };
        watch(
            () => props.modelValue,
            (newValue) => {
                if (newValue !== selectedValue.value) {
                    selectedValue.value = newValue;
                }
            });

        return {
            props,
            selectedValue,
            handleSelect,
            handleDeselect
        };
    },
});
</script>